
import Header from "../components/header";
import Sidebar from "../components/sidebar";
import NetworkWiseReport from "../components/networkWiseReport";
import Footer from "../components/footer";

function NetworkWiseReportPage() {
  return (
    <div>
    <div className='wrapper'>
      <Header />
      <Sidebar /> 
      <NetworkWiseReport /> 
    </div>
    <Footer /> 
  </div>
  // <Login/>
  );
}
export default NetworkWiseReportPage;
